import Debug from 'debug'
const debug = Debug('app:settings:billing')
import '../settings.css'

class Invoices {
  /* @ngInject */
  constructor (Auth, $state, $mdToast, $q, $mdDialog, $scope, $mdMedia, $rootScope, invoices, Companies, $window, $sce) {
    this.Auth = Auth
    this.$mdMedia = $mdMedia
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$rootScope = $rootScope
    this.$window = $window
    this.$scope = $scope
    this.Companies = Companies
    this.$q = $q
    this.$state = $state
    this.invoiceList = invoices.Invoice || []
    this.sortReverse = false
    debug('got invoices %o', this.invoiceList)
  }

  pdfInvoice (invoiceId) {
    this.$rootScope.$broadcast('app:loading:start')
    this.Companies.fetchInvoicePDF(invoiceId)
      .then(this.getPdfData.bind(this))
      .then(this.stopLoader.bind(this))
  }
  getPdfData (pdfData) {
    var file = new Blob([pdfData.data], {type: 'application/pdf'})
    var fileURL = URL.createObjectURL(file)
    window.open(fileURL)
  }

  attachments (invoiceId) {
    this.$rootScope.$broadcast('app:loading:start')
    this.Companies.fetchAttachments(invoiceId)
        .then(xlsxObj => {
          // We expect now BLOB with xlsx file
          var file = new Blob([new Uint8Array(xlsxObj.data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(file)
          link.download = xlsxObj.filename
          link.click()
        })
        .then(this.stopLoader.bind(this))
  }

  stopLoader () {
    this.$rootScope.$broadcast('app:loading:done')
  }

  // Get URL for customer magic link and open url
  manageAndPayInvoices() {
    this.$rootScope.$broadcast('app:loading:start')
    this.Companies.fetchMagicLink()
        .then(url => {
          window.open(url)
          this.stopLoader()
      }).catch(err => {
      console.log(err);
      this.stopLoader()
      this.$mdToast.showSimple(err.data.reason)
    })
  }

}

export default Invoices
